import React from 'react'

import { Link } from '@toptal/picasso'

import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { mergeRequested } from '../../actions'

interface IProps {
  label: string
  onClick(event: React.MouseEvent): void
}

const MergeLink: React.FunctionComponent<IProps> = ({ label, onClick }) => {
  return (
    <Link tabIndex={0} onClick={onClick}>
      {label}
    </Link>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClick: () => dispatch(mergeRequested())
})

const MergeLinkSmart = connect(
  null,
  mapDispatchToProps
)(MergeLink)

export default MergeLinkSmart
